import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'

import auth from '@/auth'
import config from '@/config'
import userType from './../auth/userType'

// Views
import LoginPage from '@/views/pages/Login'
import Page404 from '@/views/pages/Page404'
import Page401 from '@/views/pages/Page401'
import ProjectList from '@/views/project/ProjectList'
import FormList from '@/views/form/FormList'
import FormSingle from '@/views/form/FormSingle'
import LeadList from '@/views/lead/LeadList'

Vue.use(Router)
auth.checkAuth()

const router = new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'Home',
      redirect: 'forms/list',
      component: Full,
      meta: {
        label: 'Projekty',
        requiresAuth: true,
        allowRoles: [userType.admin, userType.user, userType.copywriter, userType.client]
      },
      children: [
        {
          path: 'projects',
          name: 'projects',
          redirect: 'projects/list',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'Projekty',
            requiresAuth: true,
            allowRoles: [userType.admin, userType.user]
          },
          children: [
            {
              path: 'list',
              name: 'projects-list',
              component: ProjectList,
              meta: {
                label: 'Projekty',
                requiresAuth: true,
                allowRoles: [userType.admin, userType.user]
              }
            }
          ]
        },
        {
          path: 'forms',
          name: 'forms',
          redirect: 'forms/list',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'Formularze',
            requiresAuth: true,
            allowRoles: [userType.admin, userType.user]
          },
          children: [
            {
              path: 'list',
              name: 'forms-list',
              component: FormList,
              meta: {
                label: 'Formularze',
                requiresAuth: true,
                allowRoles: [userType.admin, userType.user]
              }
            },
            {
              path: ':formId(.{36})',
              name: 'forms-single',
              props: true,
              component: FormSingle,
              // component: {
              //   render (c) { return c('router-view') }
              // },
              meta: {
                label: 'Formularz',
                requiresAuth: true,
                allowRoles: [userType.admin, userType.user]
              }
            }
          ]
        },
        {
          path: 'leads',
          name: 'leads',
          redirect: 'leads/list',
          component: {
            render (c) { return c('router-view') }
          },
          meta: {
            label: 'Leady',
            requiresAuth: true,
            allowRoles: [userType.admin, userType.user]
          },
          children: [
            {
              path: 'list',
              name: 'leads-list',
              component: LeadList,
              meta: {
                label: 'Leady',
                requiresAuth: true,
                allowRoles: [userType.admin, userType.user]
              }
            }
          ]
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      props: true,
      component: LoginPage,
      meta: {
        label: 'Logowanie',
        allowRoles: [userType.admin, userType.copywriter, userType.client, userType.user]
      }
    },
    {
      path: '/401',
      name: 'Page401',
      component: Page401
    },
    {
      path: '/404',
      name: 'Page404',
      component: Page404
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next('/404')
  } else if (document.referrer.includes(config.services.users.url)) {
    Object.defineProperty(document, 'referrer', { get: () => { return window.location.origin } })
    auth.logout()
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!auth.user.authenticated || !localStorage.getItem('id_token')) {
      localStorage.setItem('redirectTo', to.fullPath)
      next({ path: '/login' })
    } else if (to.matched.some(record => record.meta.allowRoles.indexOf(userType.getCurrentUserType()) === -1)) {
      next({ path: '/401' })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router
